import { InterVariableFontFamily } from './theme'

export const InterVariableFontFamilyTheme = {
  typography: {
    fontFamily: InterVariableFontFamily,
  }
}
